import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=c1c380c4&"
import script from "./Award.vue?vue&type=script&lang=ts&"
export * from "./Award.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports